import { assign } from 'lodash';
import { ActionType, IAction } from '../actions/actions';
import { ModalState } from '../../../classes/modal';
import { IMediaGalleryItem } from '../../../classes/media-gallery';

export interface ModalModel {
    modalState: ModalState;
    content: IMediaGalleryItem;
};

export const defaultModalModel: ModalModel = {
    modalState: ModalState.CLOSED,
    content: null
};

export default function modalReducer(state: ModalModel = defaultModalModel, action: IAction) {
    switch (action.type) {
        case ActionType.OPEN_MODAL: {
            return assign({}, state, { modalState: ModalState.OPENED });
        }

        case ActionType.CLOSE_MODAL: {
            return assign({}, state, { modalState: ModalState.CLOSED });
        }

        case ActionType.SET_MODAL_CONTENT: {
            return assign({}, state, { content: action.value });
        }

        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./app/media-gallery/redux/reducers/modal.ts